export default __webpack_public_path__ + "static/media/logo-halal.44e7de2e.png";